<template>
  <page-content
    v-if="currentUser != null"
    :has-sticky-col-left="true"
    :has-left-col-small="true"
    :has-padd-right-normal="false"
    :has-padd-left-normal="false"
    :has-padd-right-on-act="false"
    :has-padd-left-on-act="false"
    :set-left-col-class="'is-narrow is-maxW300p is-minW300p is-margin-right-less is-marginless-right has-background-white is-border-right'"
    :has-left-col-collapse="true"
    :opened-col="true">
    <template slot="left-col-small">
      <div class="field is-marginless">
        <div class="control">
          <div class="has-flatpickr-responsive has-flatpickr-theme--s1 has-flatpickr-padding-h has-background-white-ter is-border-bottom is-padding-bottom-small">
            <flat-pickr
              :config="configDateMini"
              id="flatpickr"
              class="input is-hidden is-radiusless is-shadowless flatpickr-input is-noDecalPosTop"
              name="date"
              v-model="flatPickrDate"
              @on-change="goToDay"></flat-pickr>
          </div>
        </div>
      </div>
      <div>
        <div
          v-if="hasFilter"
          class="is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall is-border-top has-background-annonce">
          <a
            class="has-text-white is-size-6"
            @click.prevent.stop="resetFilters">
            <span class="icon"><i class="fas fa-undo"></i></span>
            <span class="is-italic">Réinitialiser tous les filtres</span>
          </a>
        </div>
        <div class="is-padding-top-small is-padding-left is-padding-right">
          <r-label
            :label="'Filtrage par critères :'"
            :is-required="false"></r-label>
          <div class="field is-grouped">
            <div
              v-for="type in rdvTypeList"
              :key="type.value"
              class="control is-expanded">
              <input
                :id="type.value"
                v-model="filters.rdv_type"
                :value="type.label"
                name="typeRdv"
                :class="{'is-active' : filters.rdv_type.map(x=> x.value).includes(type.value)}"
                checked="checked"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="checkbox"
                @change="updateSimpleFilter(); focus(`#${type.value}`)">
              <label :for="type.value">{{ type.label }}</label>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin || isManager"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openUserSelection('author')"
              class="input">
              <div v-if="filters.author && filters.author.length">
                <span class="">Organisateurs ({{ filters.author.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Sélectionner organisateur</span>
            </div>
          </div>
        </div>
        <div class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openContactSelection()"
              class="input">
              <div v-if="filters.contact && filters.contact.length">
                <span class="">contacts ({{ filters.contact.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Rechercher contact</span>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin || isManager"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openUserSelection('user')"
              class="input">
              <div v-if="filters.user && filters.user.length">
                <span class="">Participants ({{ filters.user.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Rechercher participant</span>
            </div>
          </div>
        </div>
        <div
          v-if="(isAdmin && isPromoteur) || currentUser.active_all_contact"
          class="field is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <multiselect
              @input="updateSimpleFilter"
              @open="!programsFilter.length ? getAgenceByName() : null"
              :loading="loadingFilters === 'agence'"
              v-model="filters.agence"
              label="name"
              track-by="pk"
              class="multiselect--option-ico is-single_choice"
              open-direction="bottom"
              :multiple="true"
              :options="agencesFilter"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              :placeholder="''">
              <span slot="noResult">Oups! Aucune agence trouvée.</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Agences</span>
              <span
                slot="selection"
                class="multiselect__placeholder"
                slot-scope="{ values }"
                v-if="values.length">
                <span>Agences ({{ values.length }})</span>
              </span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div>
      </div>
    </template>

    <template>
      <filters-tags
        id="user-tag"
        :has-filter="hasFilter"
        :filters="filters"
        @reset="resetFilters"
        @update="updateFromTag($event)"></filters-tags>
      <div class="bulmaCalendar is-fullContentHeight is-noMarginTop is-minH100">
        <div class="dateimepicker-wrapper">
          <div class="datetimepicker is-active is-large is-fullwidth is-cardless">
            <div class="datetimepicker-container">
              <div class="datepicker-body">
                <div class="datepicker-weekdays">
                  <div class="datepicker-date">
                    Lundi
                  </div>
                  <div class="datepicker-date">
                    Mardi
                  </div>
                  <div class="datepicker-date">
                    Mercredi
                  </div>
                  <div class="datepicker-date">
                    Jeudi
                  </div>
                  <div class="datepicker-date">
                    Vendredi
                  </div>
                  <div class="datepicker-date">
                    Samedi
                  </div>
                  <div class="datepicker-date">
                    Dimanche
                  </div>
                </div>
                <div class="datepicker-dates is-active">
                  <div class="datepicker-days">
                    <calendar-month-item
                      v-for="day in days"
                      :current-month="currentMonth"
                      :key="day.key"
                      :date="day.date"
                      :options="options"
                      :reminders="reminders"
                      :rdvs="rdvs"
                      :id="day.date.format('MMMMYYYYDD')">
                    </calendar-month-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-content>
</template>

<script>
import { Calendar, Filter, Quickview, FilterGetter } from '@/mixins'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  name: 'CalendarMonth',
  components: {
    CalendarMonthItem: () => import('@/components/calendar/monthView/CalendarMonthItem')
  },
  mixins: [Calendar, Filter, Quickview, FilterGetter],
  data () {
    return {
      loadDocuments: this.initMonthCalendar,
      programsFilter: []
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur'])
  },
  async created () {
    if ('calendarMonth' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    }
  },
  methods: {
    updateFilter ({ filter, array }) {
      if (!array) return
      // check if filter is date_livraison
      if (Array.isArray(filter.value)) {
        filter.value.forEach(year => {
          let i = array.findIndex(x => x === year)
          if (i >= 0) array.splice(i, 1)
          else array.push(year)
        })
      } else {
        let i = array.findIndex(x => x === filter.value)
        if (i >= 0) array.splice(i, 1)
        else array.push(filter.value)
      }
    },
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.calendarMonth)
      this.updateSimpleFilter()
    }
  }
}
</script>
